import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { ChartModule } from '@ddt-web/chart';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { DoughnutChartComponent } from './widgets';
import { EmptyColumnChartComponent } from './widgets/empty-column-chart/empty-column-chart.component';
import { FundHoldingsComponent } from './widgets/fund-holdings/fund-holdings.component';
import { IndicatorColumnChartComponent } from './widgets/indicator-column-chart';
import { WidgetContainerComponent } from './widgets/widget-container/widget-container.component';

@NgModule({
	imports: [
		CommonModule,
		DataServiceModule,
		CwpNgFrameworkModule,
		RouterModule,
		ChartModule,
		SharedModule,
		GenericDirectivesModule
	],
	declarations: [
		WidgetContainerComponent,
		EmptyColumnChartComponent,
		DoughnutChartComponent,
		FundHoldingsComponent,
		IndicatorColumnChartComponent
	],
	exports: [
		WidgetContainerComponent,
		EmptyColumnChartComponent,
		DoughnutChartComponent,
		FundHoldingsComponent,
		IndicatorColumnChartComponent
	]
})
export class AreasToExploreModule { }
